<template>
  <div>
    <navbar></navbar>
    <banner></banner>
    <about></about>
    <services></services>
    <contact></contact>
    <site-footer></site-footer>
  </div>
</template>
<script>
// @ is an alias to /src
import Navbar from "@/components/navbar.vue";
import Banner from "./banner.vue";
import About from "./about.vue";
import Services from "./services.vue";
import Contact from "./contact.vue";
import SiteFooter from "./footer.vue";

export default {
  name: "home",
  components: {
    Navbar,
    Banner,
    About,
    Services,
    Contact,
    SiteFooter
  }
};
</script>
<style lang="scss">
@import "@/styles/app.scss";
</style>

